var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('basic-heading',{attrs:{"title":""},scopedSlots:_vm._u([{key:"right-content",fn:function(){return [_c('header-button-group',{attrs:{"button_config":_vm.button_config}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }